// The checkup survey is client-facing only: agents/admins keep using the
// classic /survey/:uid pages (#598).
export default function ({ store, redirect }) {
    if (store.getters.canAgent) {
        return redirect('/survey')
    }
}
